import React, { useState, useEffect, useCallback } from "react";
import { TreeList, orderBy, filterBy, TreeListTextFilter } from "@progress/kendo-react-treelist";
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { EditingAddDialog } from "./EditingAddDialog";
import { Close, Edit } from "@mui/icons-material";
import { Dialog, DialogContent, DialogTitle, Typography } from "@mui/material";
import * as Icons from '@mui/icons-material';
import { ActionIconItem } from "../others/ActionIconItem";

const subItemsField = "children";
const expandField = "expanded";

export const KendoTreeLisEdit = ({ item, data }) => {
    function isValidJSON(str) {
        try {
            JSON.parse(str);
            return true;
        } catch (e) {
            return false;
        }
    }
    const [openDialog, setOpenDialog] = useState(false);
    const [dto, setDto] = useState(isValidJSON(data[item.form_parcer.replace(/{|}/g, "")]) ? JSON.parse(data[item.form_parcer.replace(/{|}/g, "")]) : {});
    const [open, setOpen] = useState(false);
    const [objectEdit, setObjectEdit] = useState({});
    const [action, setAction] = useState('ADDCHILDREN');
    const [path, setPath] = useState('');
    const [state, setState] = useState({
        data: [],
        dataState: {
            sort: [{ field: "field" }],
            filter: []
        }
    });

    const cellWithEditing = (props) => {
        const { dataItem } = props;
        if (dataItem?.children)
            return (
                <Tooltip title="Add">
                    <IconButton
                        color="primary"
                        variant="outlined"
                        onClick={() => handleEdit(dataItem, 'ADDCHILDREN')}
                    >
                        <AddCircleIcon />
                    </IconButton>
                </Tooltip >
            );

        if ((dataItem?.functions && Array.isArray(dataItem.functions)) || ("field_value" in dataItem && "type" in dataItem))
            return (
                <Tooltip title="Edit">
                    <IconButton
                        color="secondary"
                        variant="outlined"
                        onClick={() => handleEdit(dataItem, 'EDIT')}
                    >
                        <Edit />
                    </IconButton>
                </Tooltip >
            );
        return <Typography></Typography>;
    };

    const formatText = (props) => {
        const { dataItem } = props;
        if (dataItem?.functions && dataItem?.functions.length > 0)
            return <Typography>{dataItem?.functions.map(item => item.name).join(', ')}</Typography>
        return <Typography></Typography>
    }

    const columns = [
        {
            title: "",
            width: "20px",
            cell: cellWithEditing
        },
        { field: "field", title: "Propiedad", width: "500px", filter: TreeListTextFilter, expandable: true },
        { field: "field_value", title: "Valor", width: "200px" },
        { field: "type", title: "Tipo", width: "150px" },
        {
            title: "Funciones",
            width: "200px",
            cell: formatText
        },
    ];

    const onExpandChange = (event) => {
        const updatedData = [...state.data];
        const toggleExpand = (items) => {
            return items.map(item => {
                if (item.id === event.dataItem.id) {
                    return { ...item, expanded: !event.value };
                } else if (item.children) {
                    return { ...item, children: toggleExpand(item.children) };
                }
                return item;
            });
        };

        setState({
            ...state,
            data: toggleExpand(updatedData)
        });
    };

    const Recurrent = useCallback((obj, pth = '', ids = null) => {
        const array = [];
        if (typeof obj === 'object' && obj !== null && !Array.isArray(obj)) {
            Object.keys(obj).forEach((item, idx) => {
                const pt = pth ? `${pth}/${item}` : item
                const id = ids ? `${ids}.${idx.toString()}` : idx.toString();
                if (typeof obj[item] === "object") {
                    const jsn = obj[item];
                    if (jsn.hasOwnProperty('field_value') && jsn.hasOwnProperty('type')) {
                        array.push({
                            id: id,
                            field: item,
                            field_value: jsn?.field_value || '',
                            type: jsn?.type || '',
                            functions: jsn?.functions || [],
                            path: pt
                        });
                    }
                    else {
                        array.push({
                            id: id,
                            field: item,
                            expanded: true,
                            path: pt,
                            children: Recurrent(jsn, pt, id)
                        });
                    }
                }
                else {
                    array.push({
                        id: id,
                        field: item,
                        field_value: obj[item],
                        typeOf: typeof obj[item],
                        path: pt
                    });
                }
            })
        }
        return array;
    }, []);

    useEffect(() => {
        const array = Recurrent(dto);
        setState({
            ...state,
            data: array
        });
    }, [dto]);

    const handleEdit = (obj, action) => {
        setPath(obj.path);
        if (action === 'EDIT')
            setObjectEdit(obj);
        else
            setObjectEdit({});
        setAction(action);
        setOpen(true);
    }

    const handleSave = (obj, prop = '') => {
        let dtoSave = {};
        setDto(prevData => {
            const newData = { ...prevData };
            const keys = path.split('/');
            let current = newData;

            for (let i = 0; i < keys.length - 1; i++) {
                const key = keys[i];
                if (!current[key] || typeof current[key] !== "object") {
                    current[key] = {};
                }
                current = current[key];
            }

            const lastKey = keys[keys.length - 1];
            if (action === 'EDIT') {
                current[lastKey] = {
                    field_value: obj?.field_value || '',
                    type: obj?.type || '',
                    functions: obj?.functions || []
                };
            }
            else {
                current[lastKey] = {
                    ...current[lastKey],
                    [prop]: obj
                };
            }
            dtoSave = newData;
            return newData;
        });

        setOpen(false);
    };

    return (
        <>
            <ActionIconItem
                item={item}
                onClick={() => setOpenDialog(true)}
                defaultIcon="Task"
            />

            <Dialog
                open={openDialog}
                fullWidth
                maxWidth='lg'
                PaperProps={{
                    style: { height: '95%', overflow: 'visible' }
                }}
            >
                <DialogTitle>
                    <Typography variant='h5' component='h5'>
                        Visualizador de resultado
                    </Typography>
                    <IconButton
                        aria-label='close'
                        onClick={() => setOpenDialog(false)}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <div className="treelist-wrapper">
                        <TreeList
                            style={{ maxHeight: "550px", overflow: "auto", width: '100%' }}
                            expandField={expandField}
                            subItemsField={subItemsField}
                            onExpandChange={onExpandChange}
                            sortable={{ mode: "multiple" }}
                            {...state.dataState}
                            data={filterBy(orderBy(state.data, state.dataState.sort, subItemsField), state.dataState.filter, subItemsField)}
                            columns={columns}
                        />

                        {open &&
                            <EditingAddDialog
                                data={objectEdit}
                                open={open}
                                action={action}
                                onClose={setOpen}
                                handleSave={handleSave}
                            />
                        }
                    </div>
                </DialogContent>
            </Dialog>
        </>
    );
};
